import React, {useState, useEffect} from 'react';
import * as S from './AddCashV1.styles';
import IconSelector from '@ibibo/icon-selector';

// import Icon from 'Components/Icon/Icon.jsx';
import useWindowSize from '../../../../../../../hooks/use-window-size/src/use-window-size';

import TransactionCharge from '../TransactionCharge/TransactionCharge';
import SuccessTile from '../SuccessTile/SuccessTile';
import formatPrice from '../../../../utils/formatPrice';
import {getCookie} from '../../../../utils/getCookie';
import {redirectToSameWindowWithRefresh} from '../../../../utils/redirectWithCrId';

const priceTags = [
  {label: '₹1,00,000', price: 100000},
  {label: '₹2,00,000', price: 200000},
  {label: '₹5,00,000', price: 500000},
  {label: '₹10,00,000', price: 1000000},
];

const priceTagsAED = [
  {label: 'AED 1000', price: 1000},
  {label: 'AED 2500', price: 2500},
  {label: 'AED 5000', price: 5000},
  {label: 'AED 10000', price: 10000},
];

const raiseNeftRequestProcessDocUrl =
  'https://mypartnerimgak.mmtcdn.com/0UWRs5fxcvYuntRD5UAppkvBXhaYQ2rs/wblSKoHeeh.pdf';

const RaiseWalletRequestStepsCta = () => {
  return (
    <S.DescriptionText>
      <a
        onClick={() => {
          window.open(raiseNeftRequestProcessDocUrl, '_self');
        }}
      >
        Steps to raise deposit request
      </a>
    </S.DescriptionText>
  );
};

const AddCashV1 = props => {
  const {
    addBalanceToWallet,
    openPayment,
    neftDetailsCaller,
    earnMore = {},
    earnMoreData = [],
    is_sub_user,
  } = props;

  const ccdeCookie = getCookie('ccde');

  const {
    incentive_percentage = 1,
    minimum_recharge = ccdeCookie == 'AE' ? 1 : 100000,
    max_incentive = 5000,
  } = earnMore || {};

  const [inputValue, setInputValue] = useState(ccdeCookie == 'AE' ? 3000 : 100000);
  const [error, setError] = useState('');
  const [incentive, setIncentive] = useState(0);
  const [openRefundForm, setOpenRefundForm] = useState(false);

  const deviceSize = useWindowSize();

  const addBalance = () => {
    if (inputValue > 0) {
      if (!error) {
        addBalanceToWallet(inputValue);
      }
    } else {
      setError('Please enter recharge amount to add balance');
    }
  };

  const onInputChange = val => {
    if (val > 1000000) {
      setError('Please enter amount less that ₹10,00,000');
    } else if (val === '' || val === 0) {
      setError('Please enter recharge amount to add balance');
      setInputValue(val);
    } else if (/^\d+$/.test(val)) {
      setError('');
      setInputValue(val);
    }
  };

  const onInputChangeAed = val => {
    if (val >= 1000000) {
      setError('Please enter amount less that AED 10,00,000');
    } else if (val === '' || val === 0) {
      setError('Please enter recharge amount to add balance');
      setInputValue(val);
    } else if (/^\d+$/.test(val)) {
      setError('');
      setInputValue(val);
    }
  };

  const calculateIncentive = price => {
    if (price >= minimum_recharge) {
      for (let j = 0; j < earnMoreData.length; j++) {
        if (earnMoreData[j].min_amount <= price && earnMoreData[j].max_amount >= price) {
          //amnt found

          let incentive = Math.min(
            price * (earnMoreData[j].percentage / 100),
            earnMoreData[j].max_incentive,
          );
          return Number(incentive.toFixed(2));
        }
      }
      //return Math.min(price * (arr[j].incentive_percentage / 100), max_incentive);
    }
    //return Math.min(price * (arr[j].incentive_percentage / 100), max_incentive);
  };

  useEffect(() => {
    setIncentive(calculateIncentive(inputValue));
  }, [inputValue, earnMoreData]);

  const renderIncentiveTag = price => {
    const incentiveOnPrice = calculateIncentive(price);
    return incentiveOnPrice ? (
      <S.PriceTag
        className={incentiveOnPrice >= 10000 ? 'font9' : ''}
      >{`₹${incentiveOnPrice} cashback`}</S.PriceTag>
    ) : null;
  };

  const renderIncentiveTagAed = price => {
    const incentiveOnPrice = calculateIncentive(price);
    return incentiveOnPrice ? (
      <S.PriceTag
        className={
          `${incentiveOnPrice >= 10000 || ccdeCookie == 'AE' ? 'font9' : ''} ` +
          `${deviceSize.width < 768 ? 'width90' : 'width100'}`
        }
      >{`AED ${incentiveOnPrice} cashback`}</S.PriceTag>
    ) : null;
  };

  const openRefundRequestPage = () => {
    //window.open('/myrefundrequests/', '_self');
    redirectToSameWindowWithRefresh('/myrefundrequests');
  };
  const isBeforeOrEqualToJan152024 = (dateStr): boolean => {
    const currentDate = new Date();
    const targetDate = new Date(dateStr);
    return currentDate.getTime() <= targetDate.getTime();
  };
  const getLabel = () => {
    return isBeforeOrEqualToJan152024('2025-01-15') ? 'OFFER - Earn O.5% Extra DI' : 'Recommended';
  };

  return (
    <React.Fragment>
      <S.addCashWrap>
        <S.Heading>
          {ccdeCookie === 'AE' ? (
            <img width={36} src="https://assets-gos3.goibibo.com/myp_MYCASH_AED-1678423545.svg" />
          ) : (
            <IconSelector iconKey="mycash" />
          )}
          <S.AddCashTextWrap>Add My Cash</S.AddCashTextWrap>
        </S.Heading>
        <S.AddCashBody>
          <S.Recharge>
            <S.RegTitle>Recharge Online</S.RegTitle>

            {deviceSize.width > 768 && (
              <S.PriceList marginBottom="24px">
                {ccdeCookie === 'AE'
                  ? priceTagsAED.map((item, index) => (
                      <S.PriceListItem
                        selected={item.price === +inputValue}
                        onClick={() => onInputChangeAed(item.price)}
                        key={index}
                      >
                        {renderIncentiveTagAed(item.price)}
                        {item.label}
                      </S.PriceListItem>
                    ))
                  : priceTags.map((item, index) => (
                      <S.PriceListItem
                        selected={item.price === +inputValue}
                        onClick={() => onInputChange(item.price)}
                        key={index}
                      >
                        {renderIncentiveTag(item.price)}
                        {item.label}
                      </S.PriceListItem>
                    ))}
              </S.PriceList>
            )}
            <S.RegHeading>Enter Recharge Amount {ccdeCookie === 'AE' ? 'AED' : `(₹)`}</S.RegHeading>
            <S.InputCont>
              <input
                type="text"
                placeholder={ccdeCookie == 'AE' ? 'AED 3000' : '₹1,000'}
                value={inputValue}
                onChange={event => {
                  ccdeCookie === 'AE'
                    ? onInputChangeAed(event.target.value)
                    : onInputChange(event.target.value);
                }}
              />
              {deviceSize.width > 768 && (
                <S.BtnAddBalance onClick={addBalance}>ADD BALANCE</S.BtnAddBalance>
              )}
            </S.InputCont>
            {error && <S.ErrMsg>{error}</S.ErrMsg>}
            {!!incentive && (
              <S.SuccessMsg>
                Cashback worth{' '}
                <span>{formatPrice(incentive, ccdeCookie == 'AE' ? 'AED' : 'INR')}</span> will be
                credited to your wallet post successful recharge{' '}
              </S.SuccessMsg>
            )}
            {deviceSize.width < 768 && (
              <S.PriceList marginTop="20px">
                {ccdeCookie === 'AE'
                  ? priceTagsAED.map((item, index) => (
                      <S.PriceListItem
                        selected={item.price === +inputValue}
                        onClick={() => onInputChange(item.price)}
                        key={index}
                      >
                        {renderIncentiveTagAed(item.price)}
                        {item.label}
                      </S.PriceListItem>
                    ))
                  : priceTags.map((item, index) => (
                      <S.PriceListItem
                        selected={item.price === +inputValue}
                        onClick={() => onInputChange(item.price)}
                        key={index}
                      >
                        {renderIncentiveTag(item.price)}
                        {item.label}
                      </S.PriceListItem>
                    ))}
              </S.PriceList>
            )}
            {deviceSize.width < 768 && (
              <S.BtnAddBalance onClick={addBalance}>ADD BALANCE</S.BtnAddBalance>
            )}
          </S.Recharge>
          <S.Or>- OR - </S.Or>
          {ccdeCookie === 'AE' ? (
            <S.RgtsWrap>
              <S.RecTag>Recommended</S.RecTag>
              <S.Title>Recharge via Account Deposit {/* <S.New>NEW</S.New> */}</S.Title>

              <S.Text>
                Transfer money to myPartner account number to load money to your myPartner wallet.
              </S.Text>
              {ccdeCookie === 'AE' ? (
                <S.NoteText>
                  Note: For any bank transfer or cash deposit made after 9:30 PM GST, wallet top-up
                  will be processed by 9 AM GST the following day.
                </S.NoteText>
              ) : null}
              {ccdeCookie !== 'AE' ? (
                <S.SmallText>
                  (Wallet gets automatically recharged within 3hrs of bank transfer)
                </S.SmallText>
              ) : null}
              <S.ViewDtls onClick={neftDetailsCaller}>View Account Details</S.ViewDtls>
              <S.DescriptionText>
                <a onClick={openRefundRequestPage}>Submit Deposit Request</a>
              </S.DescriptionText>
              {!is_sub_user && ccdeCookie == 'AE' ? <RaiseWalletRequestStepsCta /> : null}
            </S.RgtsWrap>
          ) : (
            <S.RgtsWrap>
              <S.RecTag>{getLabel()}</S.RecTag>
              <S.Title>Recharge via NEFT/RTGS {/* <S.New>NEW</S.New> */}</S.Title>
              <S.NoExtra>
                (<span>no Extra charges</span>)
              </S.NoExtra>
              <S.Text>
                Transfer money to your Unique Virtual Account number to load money to your myPartner
                wallet.{' '}
              </S.Text>
              <S.SmallText>
                (Wallet gets automatically recharged within 3hrs of bank transfer)
              </S.SmallText>
              <S.ViewDtls onClick={neftDetailsCaller}>View Account Details</S.ViewDtls>
              <S.DescriptionText>
                Money deducted but wallet not recharged?{' '}
                <a onClick={openRefundRequestPage}>Raise here</a>
              </S.DescriptionText>

              {!is_sub_user && ccdeCookie == 'AE' ? <RaiseWalletRequestStepsCta /> : null}
            </S.RgtsWrap>
          )}
        </S.AddCashBody>
        {/* <TransactionCharge
          heading="Bank Transaction Charge"
          subHeading="Payment Gateway /Credit /Debit Cards ; Visa/Master Card 1.0 % + Applicable Taxes for all Domestic Credit Cards,"
        /> */}
        {/* {width < breakpoint && <SuccessTile />} */}
      </S.addCashWrap>
    </React.Fragment>
  );
};

export default AddCashV1;
